import { motion } from 'framer-motion';
import cn from 'classnames';

import { FM_FADE } from '@/shared/lib/animations';

import { Processing } from '@lst/mk-react-uikit';

import cls from './styles.module.pcss';

interface Props {
  fit?: boolean,
  fullscreen?: boolean,
}

export function Loader({ fit, fullscreen }: Props) {
  return (
    <motion.div
      className={cn(cls.Loader, {
        [cls.LoaderFit]: fit,
        [cls.LoaderFS]: fullscreen,
      })}
      {...FM_FADE}
    >
      <Processing isFetching className={cls.LoaderProcessing} />
    </motion.div>
  );
}
